export default "__VITE_ASSET__BhuOXzeg__"